import { createTableOrder, updateTableOrder, getOrderInfo, createOnlineOrder } from '../../services/products'

const state = {
    cartProducts: localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : {},
    submittedOrder: null
}

const getters = {
    totalCartPrice: () => {
        return Object.keys(state.cartProducts).reduce((total, key) => {
            const price = state.cartProducts[key].count * state.cartProducts[key].price;
            total += price
            return total
        }, 0)
    }
}

const actions = {
    setCartProduct({ commit }, product) {
        commit('SET_PRODUCT', product)
    },
    removeCartProduct({ commit }, product) {
        commit('REMOVE_PRODUCT', product)
    },
    removeCartItem({ commit }, product) {
        commit('REMOVE_FULL_PRODUCT', product)
    },
    async requestTableOrder({ commit }, payload) {
        const response = await createTableOrder(payload)
        commit('SET_SUBMITTED_ORDER', response.data.order)
    },
    async requestOnlineOrder({ commit }, payload) {
        const response = await createOnlineOrder(payload)
        commit('SET_SUBMITTED_ORDER', response.data.order)
    },
    async updateOrder({ commit }, { payload, uuid }) {
        const response = await updateTableOrder(payload, uuid)
        commit('SET_SUBMITTED_ORDER', response.data.order)
    },
    async getOrderInfo({ commit }, uuid) {
        const response = await getOrderInfo(uuid)
        commit('SET_SUBMITTED_ORDER', response.data)
    },
    async emptyCard({ commit }) {
        commit('SET_EMPTY_CART')
    }
}

const mutations = {
    SET_PRODUCT: (state, value) => {
        const isExist = state.cartProducts[value.id]
        if (isExist) {
            state.cartProducts[value.id].count += 1
        } else {
            state.cartProducts[value.id] = { ...value, ...{ count: 1 }}
        }
        localStorage.setItem('cart', JSON.stringify(state.cartProducts))
        state.cartProducts = {...state.cartProducts}
    },
    REMOVE_PRODUCT: (state, value) => {
        const isExist = state.cartProducts[value.id]
        if (isExist) {
            state.cartProducts[value.id].count -= 1
            if (state.cartProducts[value.id].count === 0) {
                delete state.cartProducts[value.id]
            }
        }
        localStorage.setItem('cart', JSON.stringify(state.cartProducts))
        state.cartProducts = {...state.cartProducts}
    },
    REMOVE_FULL_PRODUCT: (state, value) => {
        const products = { ...state.cartProducts }
        delete products[value.id]
        localStorage.setItem('cart', JSON.stringify(products))
        state.cartProducts = products
    },
    SET_SUBMITTED_ORDER: (state, value) => {
        state.submittedOrder = {...value}
    },
    SET_EMPTY_SUBMITTED_ORDER: (state) => {
        state.submittedOrder = null
    },
    SET_EMPTY_CART: (state) => {
        state.cartProducts = {}
        localStorage.setItem('cart', JSON.stringify(state.cartProducts))
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }
  